import './apps/bankrate-ga-dataLayer'
